import { Alert } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router';
import { api } from '../api/client';
import { SECTION_CATALOG } from '../api/generated/section-catalog';
import { useSections } from '../section-context';
import { useWorkspace } from '../workspace-context';
import { createActivityReporter, type VisitScope } from './reporter';

export function ActivityTracker() {
  const { pathname } = useLocation();
  const { user, activeWorkspace, loading, error: workspaceError } = useWorkspace();
  const { visibleSections } = useSections();
  const report = useRef<ReturnType<typeof createActivityReporter> | null>(null);
  if (!report.current) report.current = createActivityReporter((scope) => api.activityVisit(scope));
  const [error, setError] = useState(false);
  const section = SECTION_CATALOG.find(
    ({ path }) => pathname === path || pathname.startsWith(`${path}/`),
  );
  let scope: VisitScope | null = null;
  if ((pathname === '/admin' || pathname.startsWith('/admin/')) && user.isAdmin) {
    scope = { sectionId: 'admin' };
  } else if (section && visibleSections.some(({ id }) => id === section.id)) {
    if (section.id === 'documentation') scope = { sectionId: section.id };
    else if (!loading && !workspaceError)
      scope = activeWorkspace
        ? { sectionId: section.id, workspaceId: activeWorkspace.id }
        : { sectionId: 'cabinet' };
  } else if (pathname === '/' && visibleSections.length === 0) {
    scope = { sectionId: 'cabinet' };
  }
  const sectionId = scope?.sectionId;
  const workspaceId = scope?.workspaceId;
  useEffect(() => {
    if (!sectionId) return;
    let mounted = true;
    const visit = () => {
      if (document.visibilityState !== 'visible') return;
      void report.current!(user.id, { sectionId, ...(workspaceId ? { workspaceId } : {}) }).then(
        () => {
          if (mounted) setError(false);
        },
        () => {
          console.warn('Не удалось записать посещение раздела; статистика может быть неполной');
          if (mounted) setError(true);
        },
      );
    };
    visit();
    document.addEventListener('visibilitychange', visit);
    return () => {
      mounted = false;
      document.removeEventListener('visibilitychange', visit);
    };
  }, [sectionId, workspaceId, user.id]);
  return error && user.isAdmin ? (
    <Alert severity="warning" sx={{ mb: 2 }}>
      Не удалось записать посещение. Статистика активности может быть неполной.
    </Alert>
  ) : null;
}
